import Chip from "@mui/material/Chip";
import { parseISOToEpoch } from "../../../../utils/parseISOToEpoch";

export const TILE_STATUS = {
    UP_TO_DATE: "up_to_date",
    STALE: "stale",
    GENERATING: "generating",
    FAILED: "failed",
    UNKNOWN: "unknown",
};

export const PIT_GEOJSON_DATASET_TYPE = "pit-geojson";
export const PIT_GEOJSON_TILES_DATASET_TYPE = "pit-geojson-tiles";
export const TILE_GENERATION_PROCESS_TYPE = "GeneratePitGeojsonTiles";

const findPitGeojsonInput = (run) =>
    (run?.input_datasets || run?.inputs || []).find((d) => d?.dataset_type === PIT_GEOJSON_DATASET_TYPE);

export const deriveStatus = ({ latestGeojsonDttm, latestTilesRun, hasRunningRun }) => {
    if (hasRunningRun) return TILE_STATUS.GENERATING;
    if (!latestTilesRun) {
        return latestGeojsonDttm ? TILE_STATUS.STALE : TILE_STATUS.UNKNOWN;
    }
    if (latestTilesRun.status === "failure" || latestTilesRun.status === "failed") {
        return TILE_STATUS.FAILED;
    }
    if (!latestGeojsonDttm) return TILE_STATUS.UNKNOWN;
    const tilesInputDttm = findPitGeojsonInput(latestTilesRun)?.version_dttm;
    if (!tilesInputDttm) return TILE_STATUS.STALE;
    return parseISOToEpoch(tilesInputDttm) >= parseISOToEpoch(latestGeojsonDttm)
        ? TILE_STATUS.UP_TO_DATE
        : TILE_STATUS.STALE;
};

export const statusChip = (status) => {
    switch (status) {
        case TILE_STATUS.UP_TO_DATE:
            return <Chip label="Tiles up to date" color="success" size="small" />;
        case TILE_STATUS.STALE:
            return <Chip label="Tiles stale" color="warning" size="small" />;
        case TILE_STATUS.GENERATING:
            return <Chip label="Generating tiles…" color="primary" size="small" />;
        case TILE_STATUS.FAILED:
            return <Chip label="Tile generation failed" color="error" size="small" />;
        case TILE_STATUS.UNKNOWN:
        default:
            return <Chip label="No tiles yet" size="small" />;
    }
};
